module.exports = __webpack_public_path__ + "static/media/ATS-V2-Gestionnaires.0221117b.jpg";